module.exports = __webpack_public_path__ + "img/t-underline-icon.fd187b6a.svg";